import { FC } from 'react';

export const PageNotFound: FC = () => {
  return <div className="text-white p-4">Page not found</div>;
};

export default PageNotFound;
